module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dt-usa-600.c3ca4d60d9ee7bb3.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/dt-usa-600.c3ca4d60d9ee7bb3.png",width: 600,height: 450}],
        src: "https://static.sniffspot.com/packs/img/dt-usa-600.c3ca4d60d9ee7bb3.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dt-usa-600.c3ca4d60d9ee7bb3.png"},
        
        width: 600,
        height: 450
      }